var _templateObject, _templateObject2, _templateObject3;

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

import React from "react";
import styled from "styled-components";
import { Box, Container, colorsPropType, Tiles, spacingPropTypeMap } from "@nib/layout";
import Heading from "@nib-components/heading";
import { mb, px } from "styled-components-spacing";
import breakpoint from "styled-components-breakpoint";
import Feature, { validTitleValues } from "./Feature";
var BoxWrapper = styled(Box)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  ", ";\n"])), px({
  xs: 0,
  sm: 5
}));
export var FeaturePanelTitle = styled(Heading)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  text-align: center;\n  ", ";\n\n  ", ";\n"])), mb(3), breakpoint("md")(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    ", ";\n  "])), mb(6)));

var FeaturePanel = function FeaturePanel(props) {
  var title = props.title,
      _props$titleComponent = props.titleComponent,
      titleComponent = _props$titleComponent === void 0 ? "h2" : _props$titleComponent,
      _props$displayIcons = props.displayIcons,
      displayIcons = _props$displayIcons === void 0 ? true : _props$displayIcons,
      children = props.children,
      space = props.space,
      background = props.background,
      color = props.color,
      iconFill = props.iconFill,
      iconAccentFill = props.iconAccentFill,
      otherProps = _objectWithoutProperties(props, ["title", "titleComponent", "displayIcons", "children", "space", "background", "color", "iconFill", "iconAccentFill"]);

  var featureCount = React.Children.count(children); //warn the user if they provide not-enough or too many features
  //eslint-disable-next-line no-undef

  if (process.env.NODE_ENV !== "production") {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    var invariant = require("invariant");

    invariant(featureCount >= 2 || featureCount <= 4, "@nib-components/feature-panel: Must have 2-4 features.");
  }

  var featureSize = function featureSize() {
    if (featureCount === 1) {
      return 1;
    } else if (featureCount === 2 || featureCount === 4) {
      return 2;
    } else {
      return 3;
    }
  };

  var panelTitle = title && /*#__PURE__*/React.createElement(FeaturePanelTitle, {
    component: titleComponent,
    size: {
      xs: 3,
      md: 2
    }
  }, title);
  return /*#__PURE__*/React.createElement(Box, _extends({
    background: background,
    color: color,
    paddingVertical: {
      xs: 6,
      sm: 8
    },
    paddingHorizontal: {
      xs: 4,
      sm: 5
    }
  }, otherProps), /*#__PURE__*/React.createElement(Container, null, panelTitle, /*#__PURE__*/React.createElement(Tiles, {
    space: space,
    columns: {
      xs: 1,
      lg: featureSize()
    }
  }, React.Children.map(props.children, function (child) {
    return /*#__PURE__*/React.createElement(BoxWrapper, {
      padding: 5,
      paddingVertical: {
        lg: 6
      },
      height: "100%"
    }, /*#__PURE__*/React.cloneElement(child, {
      displayIcons: displayIcons,
      iconFill: iconFill,
      iconAccentFill: iconAccentFill
    }));
  }))));
};

FeaturePanel.displayName = "FeaturePanel";
FeaturePanel.defaultProps = {
  space: 0
};
FeaturePanel.Feature = Feature;
export default FeaturePanel;